import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Plannings from './views/Plannings.vue'
import Discussions from './views/Discussions.vue'
import Explore from './views/Explore.vue'
import Achievements from './views/Achievements.vue'
import Profile from './views/Profile.vue'
import Planning from './views/Planning.vue'
import Merge from './views/Merge.vue'
import Week from './views/Week.vue'
import Settings from './views/Settings.vue'
import PlanningEditor from './views/PlanningEditor.vue'
import SchoolStructure from './views/admin/SchoolStructure.vue'
import UserOverview from './views/admin/UserOverview.vue'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{ path: '/', name: 'home', component: Home },
		{ path: '/login', name: 'login', component: Login },
		{ path: '/register', name: 'register', component: Register },
		{ path: '/verify/:token', name: 'verify', component: Login },
		{ path: '/plannings', name: 'plannings', component: Plannings },
		{ path: '/discussions', name: 'discussions', component: Discussions },
		{ path: '/explore', name: 'explore', component: Explore },
		{ path: '/achievements', name: 'achievements', component: Achievements },
		{ path: '/profile/:username', name: 'profile', component: Profile },
		{ path: '/planning/edit', name: 'planning-editor-create', component: PlanningEditor },
		{ path: '/planning/edit/:id', name: 'planning-editor-edit', component: PlanningEditor },
		{ path: '/planning/:id', name: 'planning', component: Planning },
		{ path: '/planning/:id/merge', name: 'merge', component: Merge },
		{ path: '/settings', name: 'settings', component: Settings },
		{ path: '/week', name: 'week', component: Week },
		{ path: '/week/:date', name: 'week-date', component: Week },
		{ path: '/admin/school-structure', name: 'school-structure', component: SchoolStructure },
		{ path: '/admin/user-overview', name: 'user-overview', component: UserOverview }
	]
})
